<template>
  <div class="region_stype ">
    <view-title :titleName="asseProps.sceneTitleName"></view-title>
    <scene-view :sceneList="ServeData.sceneList" viewType="home"></scene-view>
    <view-title :titleName="asseProps.deviceTitleName"></view-title>
    <device-view :deviceList="ServeData.deviceList"></device-view>

    <!-- <collect-scene-title></collect-scene-title>
    <scene-view></scene-view>
    <collect-device-title></collect-device-title>-->
  </div>
</template>

<script>
// import CollectSceneTitle from 'components/content/controllist/sceneList/collect-scene-title'
// import CollectDeviceTitle from 'components/content/controllist/deviceList/collect-device-title'
// import SceneView from 'components/content/controllist/sceneList/scene-view'
import viewTitle from 'components/content/contro-view/view-title'
import SceneView from 'components/content/contro-view/scene-view/scene-view'
import DeviceView from 'components/content/contro-view/device-view/device-view'
import { createSocket, closeSoket } from 'common/webSoket'

export default {
  name: 'home',
  components: {
    viewTitle,
    SceneView,
    DeviceView
    // CollectSceneTitle,
    // CollectDeviceTitle,
    // SceneView
  },
  data() {
    return {
      asseProps: {
        ////决定title组件显示形式的变量值
        sceneTitleName: '常用场景',
        deviceTitleName: '常用设备'
      },
      ServeData: {
        deviceList: [],
        sceneList: []
      }
    }
  },
  watch: {
    '$store.state.publicinfo.homeServeData': {
      handler(newValue, oldValue) {
        console.log('常用页面展示数据发生了改变1')
        this.ServeData = newValue
      },
      deep: true //深度监听,监听数组的第二层数据变化
    }
  },
  methods: {
    // //监听ws数据响应
    // getDataFunc(e) {
    //   ///soket的数据返回
    //   console.log('soket服务端发来消息')
    //   console.log(e.detail.data)
    // }
  },

  beforeCreate() {
    ///钩子函数：vue实例的挂载元素$el和数据对象data都为undefined，还未初始化。
  },
  created() {
    ///钩子函数: vue实例的数据对象data有了，$el还没有
    console.log('HOME被创建了')
    createSocket(this) //创建 soket
  },
  beforeMount() {
    ///钩子函数: vue实例的$el和data都初始化了，但还是虚拟的dom节点，具体的data.filter还未替换。
  },
  activated() {
    console.log('HOME被激活了')
    // console.log(typeof this.$store.getters.getToken)

    // console.log(this.$store.getters.getToken)
    /// 获取首页常用数据接口
    this.$request({
      method: 'post',
      url: '/home/findCommonlyPage',
      data: {
        token: this.$store.state.token,
        // token: this.$store.getters.getToken,
        regionId: '',
        followState: '1' ////0未收藏的  1收藏的
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message)
          ////说明信息填写错误,控制失败了，
          return
        } else {
          ////、控制成功了
          this.ServeData = res.data.data ////拿到服务器返回的数据结果
          // this.$store.dispatch('asyUpdataServeData', res.data.data) ///异步提交当前页面需要展示的控制数据

          this.$store.dispatch('asyUpdatahomeServeData', this.ServeData) ///异步提交当前页面需要展示的控制数据,用于状态更新
          // this.$store.state.publicinfo.homeSceneCount = this.ServeData.sceneList.length
          console.log('home请求到的数据' + this.ServeData)
          this.$store.dispatch(
            'asyUpdatahomeSceneCount',
            this.ServeData.sceneList.length
          ) ///异步提交得到的数组长度
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  mounted() {
    //vue实例挂载完成，data.filter成功渲染  一般数据请求放在这里
    console.log('HOME被渲染成功了')
    // sendWSPush(11111) //发送数据 soket发送数据
    // window.addEventListener('onmessageWS', this.getDataFunc) ///创建关联监听消息事件
  },
  beforeDestroy() {
    ////组件销毁前调用
    console.log('HOME被销毁前')
    // //根据需要，销毁事件监听 soket的事件
    // window.removeEventListener('onmessageWS', this.getDataFunc)
  },
  destroyed() {
    console.log('HOME被销毁后')
    closeSoket() ///关闭soket
  }
}
</script>

<style>
/* h1 {
  height: 50px;
} */
</style>
